<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md6>
        <material-card>
          <v-card-text class="text-center">
            <v-img :src="image" height="100%"></v-img>
            <h3>404 - The page you're looking for is not here!</h3>
            <p class="category mb-3">
              Sorry about that, perhaps you need to sign in as a different user to access this page?
            </p>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script lang="js">
export default {
  data() {
    return {
      error: '',
      image: './img/GlitchedLogo_BiColor2_sml.png',
    };
  },
};
</script>
